module.exports = __webpack_public_path__ + "img/rader-hero.4a3e1968.jpg";